export const translations = {
  gr: {
    nav: { book: "Κλείσε ραντεβού", admin: "Διαχείριση", products: "Προϊόντα" },
    hero: {
      eyebrow: "Michalis Christofi Pharmacy",
      title: "Τρύπημα Αυτιών & Μύτης",
      subtitle:
        "Ασφαλής, υγιεινή διαδικασία στο φαρμακείο μας, από εξειδικευμένο προσωπικό. Κλείσε online το ραντεβού σου σε λίγα δευτερόλεπτα.",
      cta: "Κλείσε ραντεβού",
      learn: "Μάθε περισσότερα",
    },
    info: {
      procedureTitle: "Η διαδικασία",
      procedureBody:
        "Χρησιμοποιούμε αποστειρωμένα, ατομικά σετ και υποαλλεργικά σκουλαρίκια πρώτου τρυπήματος. Η διαδικασία είναι γρήγορη, καθαρή και σχεδόν ανώδυνη. Αξιολογούμε πρώτα το σημείο και απαντάμε σε όλες τις ερωτήσεις σου.",
      pricesTitle: "Τιμοκατάλογος",
      priceEar: "Λοβός αυτιού",
      priceEarUnit: "/ αυτί",
      priceNose: "Μύτη",
      pricesNote: "Η πληρωμή γίνεται στο φαρμακείο. Καμία online πληρωμή.",
      aftercareTitle: "Φροντίδα μετά",
      aftercareBody:
        "Καθάριζε την περιοχή 2 φορές την ημέρα με φυσιολογικό ορό ή με ήπιο αντισηπτικό διάλυμα. Απόφυγε το άγγιγμα με βρώμικα χέρια, πισίνες και θάλασσα για 2-3 εβδομάδες. Μη γυρίζεις το σκουλαρίκι χωρίς λόγο. Σε περίπτωση ερυθρότητας ή πόνου, επικοινώνησε μαζί μας.",
    },
    form: {
      title: "Κλείσε το ραντεβού σου",
      step1: "Υπηρεσία & ώρα",
      step2: "Στοιχεία & συγκατάθεση",
      selectService: "Επίλεξε υπηρεσία",
      selectDate: "Επίλεξε ημερομηνία",
      selectSlot: "Διαθέσιμες ώρες",
      season: { summer: "Θερινό ωράριο", winter: "Χειμερινό ωράριο" },
      noSlots: "Επίλεξε ημερομηνία για να δεις τις διαθέσιμες ώρες",
      booked: "Κλεισμένο",
      next: "Συνέχεια",
      back: "Πίσω",
      name: "Ονοματεπώνυμο",
      phone: "Τηλέφωνο",
      email: "Email",
      minor: "Το ραντεβού αφορά ανήλικο (κάτω των 18)",
      parentName: "Ονοματεπώνυμο γονέα/κηδεμόνα",
      parentConsent: "Ως γονέας/κηδεμόνας δίνω τη συγκατάθεσή μου",
      healthTitle: "Δήλωση υγείας",
      nickel: "Έχω αλλεργία στο νικέλιο ή γνωστές αλλεργίες",
      healthNote: "Προαιρετικό σχόλιο υγείας",
      healthNotePlaceholder: "Οτιδήποτε πρέπει να γνωρίζουμε (προαιρετικό)",
      gdpr: "Κρατάμε μόνο τα απαραίτητα στοιχεία για το ραντεβού σου (GDPR).",
      terms: "Έχω διαβάσει και αποδέχομαι τους όρους",
      total: "Σύνολο",
      submit: "Κλείσε ραντεβού",
      submitting: "Γίνεται κράτηση...",
    },
    success: {
      title: "Το ραντεβού επιβεβαιώθηκε!",
      body: "Θα λάβεις email επιβεβαίωσης. Σε περιμένουμε στο φαρμακείο.",
      another: "Νέο ραντεβού",
    },
    errors: {
      required: "Συμπλήρωσε όλα τα υποχρεωτικά πεδία",
      slot: "Επίλεξε διαθέσιμη ώρα",
      consent: "Απαιτείται συγκατάθεση γονέα για ανήλικους",
      terms: "Πρέπει να αποδεχτείς τους όρους",
      taken: "Η ώρα μόλις κλείστηκε. Επίλεξε άλλη.",
      generic: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
    },
    admin: {
      title: "Διαχείριση ραντεβού",
      date: "Ημερομηνία",
      none: "Δεν υπάρχουν ραντεβού για αυτή την ημέρα",
      status: { pending: "Σε εκκρεμότητα", completed: "Ολοκληρώθηκε", cancelled: "Ακυρώθηκε" },
      markComplete: "Ολοκληρώθηκε",
      markCancel: "Ακύρωση",
      season: "Ρυθμίσεις εποχικού ωραρίου",
      summerStart: "Έναρξη θερινού (MM-DD)",
      summerEnd: "Λήξη θερινού (MM-DD)",
      summerEvening: "Βραδινό θερινό",
      winterEvening: "Βραδινό χειμερινό",
      save: "Αποθήκευση",
      saved: "Οι ρυθμίσεις αποθηκεύτηκαν",
      back: "Πίσω στην κράτηση",
      auth: {
        title: "Είσοδος διαχείρισης",
        subtitle: "Καταχώρησε τον κωδικό προσωπικού για πρόσβαση.",
        pin: "Κωδικός (PIN)",
        enter: "Είσοδος",
        wrong: "Λάθος κωδικός",
        logout: "Αποσύνδεση",
      },
    },
    products: {
      title: "Προϊόντα",
      subtitle: "Σκουλαρίκια & προϊόντα φροντίδας — διαθέσιμα στο φαρμακείο.",
      atPharmacy: "Διαθέσιμο στο φαρμακείο",
    },
    site: {
      nav: { services: "Υπηρεσίες", offers: "Προσφορές", piercing: "Piercing", hours: "Ωράριο", contact: "Επικοινωνία", admin: "Διαχείριση" },
      openNow: "Ανοιχτά τώρα", closedNow: "Κλειστά τώρα",
      hero: {
        eyebrow: "ΦΑΡΜΑΚΕΙΟ — ΚΑΤΩ ΠΟΛΕΜΙΔΙΑ, ΛΕΜΕΣΟΣ",
        name1: "Michalis", name2: "Christofi",
        tagline: "Δίπλα σας σε κάθε βήμα υγείας.",
        sub: "Συμβουλές για Υγεία • Ομορφιά • Συμπληρώματα Διατροφής",
        call: "Καλέστε μας", directions: "Οδηγίες", piercing: "Piercing — Κλείσε ραντεβού",
      },
      offers: {
        eyebrow: "Μόνο για αυτόν τον μήνα", title: "Προσφορές του Μήνα",
        items: [
          { title: "-15% σε επιλεγμένα παπούτσια", desc: "Σε επιλεγμένα προϊόντα, μέχρι εξαντλήσεως." },
          { title: "-5€ σε αντηλιακά Avène", desc: "Μέχρι εξαντλήσεως των κουπονιών (σε επιλεγμένα προϊόντα)." },
          { title: "Back to School — SIGG παγούρια -20%", desc: "Πανάλαφρα, στεγανά, από ασφαλές αλουμίνιο ή πολυπροπυλένιο χωρίς BPA." },
        ],
      },
      services: {
        eyebrow: "Τι προσφέρουμε", title: "Υπηρεσίες",
        items: [
          { title: "Εκτέλεση Συνταγών", desc: "Άμεση και υπεύθυνη εκτέλεση συνταγών με καθοδήγηση στη σωστή λήψη φαρμάκων." },
          { title: "Μέτρηση Πίεσης", desc: "Δωρεάν μέτρηση αρτηριακής πίεσης και καταγραφή για παρακολούθηση." },
          { title: "Συμβουλές Υγείας", desc: "Εξατομικευμένες συμβουλές φαρμακοθεραπείας, συμπληρωμάτων και πρόληψης." },
        ],
      },
      hoursSection: {
        eyebrow: "Πότε θα μας βρείτε", title: "Ωράριο", note: "Θερινό & χειμερινό ωράριο",
        rows: [
          { days: "Δευτέρα, Τρίτη, Πέμπτη, Παρασκευή", hours: "08:00–13:30 & 16:00–19:30 (Θερινό)\n08:00–13:00 & 15:00–18:30 (Χειμερινό)" },
          { days: "Τετάρτη & Σάββατο", hours: "08:00–13:30" },
          { days: "Κυριακή", hours: "Κλειστά" },
        ],
      },
      contact: {
        eyebrow: "Επισκεφθείτε μας", title: "Επικοινωνία", addressLabel: "Διεύθυνση",
        address: "Μαρίνου Γερουλάνου 50, Κάτω Πολεμίδια, Λεμεσός 4154",
        phoneLabel: "Τηλέφωνο", phone: "25753000", maps: "Οδηγίες στον χάρτη", whatsapp: "WhatsApp",
      },
      piercingSection: {
        eyebrow: "Νέα υπηρεσία", title: "Τρύπημα Αυτιών & Μύτης",
        lead: "Ασφαλής, υγιεινή διαδικασία στο φαρμακείο, από εξειδικευμένο προσωπικό.", cta: "Κλείσε ραντεβού",
      },
    },
    adminProducts: {
      title: "Διαχείριση προϊόντων",
      add: "Προσθήκη προϊόντος",
      none: "Δεν υπάρχουν προϊόντα ακόμη.",
      nameGr: "Όνομα (GR)",
      nameEn: "Όνομα (EN)",
      descGr: "Περιγραφή (GR)",
      descEn: "Περιγραφή (EN)",
      price: "Τιμή (€)",
      category: "Κατηγορία",
      imageUrl: "URL εικόνας",
      active: "Ενεργό (ορατό στο site)",
      save: "Αποθήκευση",
      cancel: "Άκυρο",
      edit: "Επεξεργασία",
      delete: "Διαγραφή",
      inactive: "Ανενεργό",
      saved: "Το προϊόν αποθηκεύτηκε",
      deleted: "Το προϊόν διαγράφηκε",
    },
  },
  en: {
    nav: { book: "Book appointment", admin: "Admin", products: "Products" },
    hero: {
      eyebrow: "Michalis Christofi Pharmacy",
      title: "Ear & Nose Piercing",
      subtitle:
        "A safe, hygienic piercing service at our pharmacy, performed by trained staff. Book your appointment online in seconds.",
      cta: "Book appointment",
      learn: "Learn more",
    },
    info: {
      procedureTitle: "The procedure",
      procedureBody:
        "We use sterile, single-use kits and hypoallergenic starter studs. The process is quick, clean and virtually painless. We assess the site first and answer all your questions.",
      pricesTitle: "Price list",
      priceEar: "Ear lobe",
      priceEarUnit: "/ ear",
      priceNose: "Nose",
      pricesNote: "Payment is made at the pharmacy. No online payment.",
      aftercareTitle: "Aftercare",
      aftercareBody:
        "Clean the area twice a day with saline solution or a mild antiseptic solution. Avoid touching with dirty hands, and avoid pools and the sea for 2-3 weeks. Do not twist the earring unnecessarily. If you notice redness or pain, contact us.",
    },
    form: {
      title: "Book your appointment",
      step1: "Service & time",
      step2: "Details & consent",
      selectService: "Select a service",
      selectDate: "Select a date",
      selectSlot: "Available times",
      season: { summer: "Summer schedule", winter: "Winter schedule" },
      noSlots: "Select a date to see available times",
      booked: "Booked",
      next: "Continue",
      back: "Back",
      name: "Full name",
      phone: "Phone",
      email: "Email",
      minor: "This appointment is for a minor (under 18)",
      parentName: "Parent/guardian full name",
      parentConsent: "As a parent/guardian I give my consent",
      healthTitle: "Health declaration",
      nickel: "I have a nickel allergy or known allergies",
      healthNote: "Optional health note",
      healthNotePlaceholder: "Anything we should know (optional)",
      gdpr: "We only keep the minimum data needed for your appointment (GDPR).",
      terms: "I have read and accept the terms",
      total: "Total",
      submit: "Book appointment",
      submitting: "Booking...",
    },
    success: {
      title: "Appointment confirmed!",
      body: "You'll receive a confirmation email. We look forward to seeing you at the pharmacy.",
      another: "New booking",
    },
    errors: {
      required: "Please fill in all required fields",
      slot: "Please select an available time",
      consent: "Parental consent is required for minors",
      terms: "You must accept the terms",
      taken: "That time was just booked. Please pick another.",
      generic: "Something went wrong. Please try again.",
    },
    admin: {
      title: "Bookings management",
      date: "Date",
      none: "No bookings for this day",
      status: { pending: "Pending", completed: "Completed", cancelled: "Cancelled" },
      markComplete: "Complete",
      markCancel: "Cancel",
      season: "Seasonal schedule settings",
      summerStart: "Summer start (MM-DD)",
      summerEnd: "Summer end (MM-DD)",
      summerEvening: "Summer evening",
      winterEvening: "Winter evening",
      save: "Save",
      saved: "Settings saved",
      back: "Back to booking",
      auth: {
        title: "Admin login",
        subtitle: "Enter the staff PIN to access the dashboard.",
        pin: "PIN code",
        enter: "Enter",
        wrong: "Wrong PIN",
        logout: "Logout",
      },
    },
    products: {
      title: "Products",
      subtitle: "Earrings & aftercare products — available at the pharmacy.",
      atPharmacy: "Available at the pharmacy",
    },
    site: {
      nav: { services: "Services", offers: "Offers", piercing: "Piercing", hours: "Hours", contact: "Contact", admin: "Admin" },
      openNow: "Open now", closedNow: "Closed now",
      hero: {
        eyebrow: "PHARMACY — KATO POLEMIDIA, LIMASSOL",
        name1: "Michalis", name2: "Christofi",
        tagline: "By your side at every step of your health.",
        sub: "Advice for Health • Beauty • Nutritional Supplements",
        call: "Call us", directions: "Directions", piercing: "Piercing — Book now",
      },
      offers: {
        eyebrow: "This month only", title: "Offers of the Month",
        items: [
          { title: "-15% on selected shoes", desc: "On selected products, while stocks last." },
          { title: "-5€ on Avène sunscreens", desc: "While coupons last (on selected products)." },
          { title: "Back to School — SIGG bottles -20%", desc: "Ultra-light, leak-proof, made of safe aluminium or BPA-free polypropylene." },
        ],
      },
      services: {
        eyebrow: "What we offer", title: "Services",
        items: [
          { title: "Prescriptions", desc: "Prompt, responsible dispensing of prescriptions with guidance on correct medication use." },
          { title: "Blood Pressure", desc: "Free blood pressure measurement and recording for monitoring." },
          { title: "Health Advice", desc: "Personalised advice on pharmacotherapy, supplements and prevention." },
        ],
      },
      hoursSection: {
        eyebrow: "When to find us", title: "Opening Hours", note: "Summer & winter hours",
        rows: [
          { days: "Monday, Tuesday, Thursday, Friday", hours: "08:00–13:30 & 16:00–19:30 (Summer)\n08:00–13:00 & 15:00–18:30 (Winter)" },
          { days: "Wednesday & Saturday", hours: "08:00–13:30" },
          { days: "Sunday", hours: "Closed" },
        ],
      },
      contact: {
        eyebrow: "Visit us", title: "Contact", addressLabel: "Address",
        address: "Marinou Geroulanou 50, Kato Polemidia, Limassol 4154",
        phoneLabel: "Phone", phone: "25753000", maps: "Get directions", whatsapp: "WhatsApp",
      },
      piercingSection: {
        eyebrow: "New service", title: "Ear & Nose Piercing",
        lead: "A safe, hygienic piercing service at the pharmacy, by trained staff.", cta: "Book now",
      },
    },
    adminProducts: {
      title: "Products management",
      add: "Add product",
      none: "No products yet.",
      nameGr: "Name (GR)",
      nameEn: "Name (EN)",
      descGr: "Description (GR)",
      descEn: "Description (EN)",
      price: "Price (€)",
      category: "Category",
      imageUrl: "Image URL",
      active: "Active (visible on site)",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      inactive: "Inactive",
      saved: "Product saved",
      deleted: "Product deleted",
    },
  },
};
